import React from "react";
import { Badge, Tooltip } from "../ui";

/**
 * Visual seat grid for a vehicle.
 * occupiedMap: [{ seatNumber, studentName, admissionNo }]
 */
const SeatGrid = ({
  capacity = 0,
  occupiedMap = [],
  selectedSeat = null,
  onSelectSeat,
  readOnly = false,
}) => {
  if (!capacity || capacity < 1) {
    return (
      <p className="text-sm text-neutral-500 dark:text-neutral-400">Capacity not set for this vehicle.</p>
    );
  }

  const occupiedBySeat = {};
  occupiedMap.forEach((s) => {
    if (s.seatNumber != null) occupiedBySeat[s.seatNumber] = s;
  });

  const seats = Array.from({ length: capacity }, (_, i) => i + 1);

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-3 text-xs text-neutral-600 dark:text-neutral-300">
        <span className="inline-flex items-center gap-1">
          <span className="h-3 w-3 rounded bg-neutral-200 dark:bg-neutral-700 border border-neutral-300 dark:border-neutral-700" /> Free
        </span>
        <span className="inline-flex items-center gap-1">
          <span className="h-3 w-3 rounded bg-primary-200 border border-primary-400" /> Selected
        </span>
        <span className="inline-flex items-center gap-1">
          <span className="h-3 w-3 rounded bg-danger-50 border border-danger-500" /> Occupied
        </span>
      </div>
      <div className="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-2">
        {seats.map((n) => {
          const occ = occupiedBySeat[n];
          const isSelected = selectedSeat === n;
          const isOccupied = Boolean(occ);

          let cls =
            "h-9 w-full rounded-md text-xs font-medium border transition-colors flex items-center justify-center ";
          if (isOccupied) {
            cls += "bg-danger-50 border-danger-500 text-danger-700 cursor-not-allowed";
          } else if (isSelected) {
            cls += "bg-primary-200 border-primary-500 text-primary-900 dark:text-primary-300";
          } else {
            cls +=
              "bg-neutral-50 dark:bg-neutral-950 border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 hover:border-primary-400 hover:bg-primary-50";
            if (!readOnly && onSelectSeat) cls += " cursor-pointer";
          }

          const btn = (
            <button
              key={n}
              type="button"
              disabled={isOccupied || readOnly}
              className={cls}
              onClick={() => {
                if (!isOccupied && !readOnly && onSelectSeat) {
                  onSelectSeat(isSelected ? null : n);
                }
              }}
            >
              {n}
            </button>
          );

          if (isOccupied && occ.studentName) {
            return (
              <Tooltip
                key={n}
                content={`${occ.studentName}${occ.admissionNo ? ` (${occ.admissionNo})` : ""}`}
              >
                {btn}
              </Tooltip>
            );
          }
          return btn;
        })}
      </div>
      <div className="flex gap-2 text-xs">
        <Badge variant="default">
          {capacity - occupiedMap.length} free / {capacity} total
        </Badge>
      </div>
    </div>
  );
};

export default SeatGrid;
